import { useMemorama } from '../../context/MemoramaContext'
import { EndGameModal, useShareHandler } from '@shared'
import { CARDS_PER_SIZE } from '../../constants/memorama'

export default function MemoramaEndModal () {
  const { restartGame, resetGame, players, boardSize } = useMemorama()
  const { handleShare, isSharing, shareError, shareVisible } = useShareHandler({
    getShareBlockReason: () =>
      players.length !== 1 ? 'shared.share.singlePlayerOnly' : null,
    buildShareData: () => ({
      type: 'memorama',
      playerData: players[0],
      gameData: {
        boardSize,
        cardCount: CARDS_PER_SIZE[boardSize]
      }
    }),
    logPrefix: '[MemoramaEndModal]'
  })

  return (
    <EndGameModal
      onPlayAgain={restartGame}
      onGoHome={resetGame}
      onShare={handleShare}
      shareVisible={shareVisible}
      isSharing={isSharing}
      shareError={shareError}
    />
  )
}
